import api from 'service/api'

const dponetAPI = api.create('dponet')

const get = async (params) => {
  return await dponetAPI.get(`/document_templates/old`, {
    params,
  })
}

const getCategories = async () => {
  return await dponetAPI.get('/document_categories')
}

export default {
  get,
  getCategories,
}
